/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { Card, Spinner, Alert, Row, Col, Container } from 'react-bootstrap';
import { HiBadgeCheck } from "react-icons/hi";
import { AiFillThunderbolt } from "react-icons/ai";
import PaginationProducts from './PaginationProducts';
import { authContext } from '../../Context/AuthContext';

const imgPlaceholder = `${process.env.PUBLIC_URL}/assets/sinfoto.png`;

const ProductosFiltradosContent = ({ productos, loading, error, currentPage, totalPages, handlePageChange, handleCardClick }) => {
    const { token } = useContext(authContext);
    const pais = process.env.REACT_APP_COUNTRY || 'ARG';

    const formatNumber = (number) => {
        // Convierto a num
        const num = typeof number === 'number' ? number : parseFloat(number);
        
        // Verifico si es valido
        if (isNaN(num)) return '0,00';
        
        // Formato con separadores de miles y decimales
        return new Intl.NumberFormat('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    const renderStockInfo = (articulo) => {
        if (!token) return null;
        
        const hasStock = articulo?.Stock !== undefined && articulo?.Stock !== null;
        const hasPrice = articulo?.Precio !== undefined && articulo?.Precio !== null;
        
        // Si el stock es 0, mostrar mensaje sin stock y ocultar precio
        if (hasStock && articulo.Stock === 0) {
            return (
                <Card.Text style={{ display: 'flex', alignItems: 'center', fontSize: '0.9em', color: '#dc3545', fontWeight: '500' }}>
                    Producto sin stock
                </Card.Text>
            );
        }
        
        if (!hasStock && !hasPrice) return null;
        
        return (
            <Card.Text style={{ display: 'flex', alignItems: 'center', fontSize: '0.9em', color: '#16a34a', fontWeight: '500' }}>
                {hasStock && `Stock: ${articulo.Stock}`}
                {hasStock && hasPrice && ' | '}
                {hasPrice && articulo?.Moneda_Signo && `Precio: ${articulo.Moneda_Signo} ${formatNumber(articulo.Precio)}`}
            </Card.Text>
        );
    };

    const renderPriceNote = () => {
        if (!token) return null;
        
        if (pais === "PA") {
            return (
                <Card.Text style={{ fontSize: '0.8em', color: '#6c757d', fontStyle: 'italic' }}>
                    *No incluye ITBMS
                </Card.Text>
            );
        } else if (pais !== "USA") {
            return (
                <Card.Text style={{ fontSize: '0.8em', color: '#6c757d', fontStyle: 'italic' }}>
                    *No incluye IVA
                </Card.Text>
            );
        }
        return null;
    };
    if (loading) {
        return (
            <Container className="my-5">
                <Row className="justify-content-center">
                    <Col md={6} className="text-center">
                        <Spinner animation="border" variant="primary" style={{ width: '3.5rem', height: '3.5rem' }} />
                    </Col>
                </Row>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="my-5">
                <Row className="justify-content-center">
                    <Col md={6} className="text-center">
                        <Alert variant="danger">No se pudieron obtener los productos.</Alert>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Row>
            <Col md={12}>
                {productos.length === 0 ? (
                    <Container className="my-5">
                        <Row className="justify-content-center">
                            <Col md={6} className="text-center">
                                <h3>No se han encontrado productos</h3>
                            </Col>
                        </Row>
                    </Container>
                ) : (
                    productos.map((producto, index) => (
                        <Card
                            key={index}
                            className="mb-2 d-flex align-items-center flex-row card-hover"
                            style={{ backgroundColor: 'white', cursor: 'pointer' }}
                            onClick={() => handleCardClick(producto.Alias)}
                        >
                            <Card.Img
                                variant="top"
                                src={producto.Imagenes
                                    ? process.env.PUBLIC_URL +
                                    `/articulos/thumbs/${encodeURIComponent(producto.Imagenes.split(',')[0])}`
                                    : imgPlaceholder}
                                style={{
                                    width: '100%',
                                    maxWidth: '150px',
                                    maxHeight: '150px',
                                    objectFit: 'contain',
                                    marginRight: '15px',
                                    padding: '1em',
                                }}
                            />
                            <Card.Body>
                                <Card.Title style={{ display: 'flex', alignItems: 'center', fontSize: '0.9em' }}>
                                    {producto?.Marca || ''}
                                    <HiBadgeCheck style={{ marginLeft: '12px', color: '#007bff', fontSize: '1.5em' }} />
                                </Card.Title>
                                <Card.Title style={{ display: 'flex', alignItems: 'center', fontSize: '1.1em' }}>
                                    {producto?.Nombre || ''}
                                </Card.Title>
                                <Card.Text style={{ display: 'flex', alignItems: 'center', fontSize: '0.9em' }}>
                                    SKU: {producto?.Alias || ''}
                                </Card.Text>
                                {renderStockInfo(producto)}
                                <Card.Text style={{ display: 'flex', alignItems: 'center', fontSize: '0.9em', color: '#3b3b3bff', fontWeight: '600' }}>
                                    Garantía de {producto?.Garantia_meses || ''} meses
                                    <AiFillThunderbolt style={{ marginLeft: '8px', color: '#007bff', fontSize: '1.3em' }} />
                                </Card.Text>
                                {renderPriceNote()}
                            </Card.Body>
                        </Card>

                    ))
                )}

                <div className="d-flex justify-content-between align-items-center mt-4">
                    <PaginationProducts currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
                </div>
            </Col>
        </Row>
    );
};

export default ProductosFiltradosContent;
